import { createReducer, on, StoreModule } from '@ngrx/store';
import * as UserAuthActions from './user-auth.actions';

export const userAuthFeatureKey = 'userAuth';

export interface UserAuthState {
    isAuthenticated: boolean | null;
}

export const initialState: UserAuthState = {
    isAuthenticated: null,
};

export const userAuthReducer = createReducer(
    initialState,
    on(UserAuthActions.SetIsAuthenticated, (state, { isAuthenticated }) => {
        return {
            ...state,
            isAuthenticated,
        };
    })
);

export const userAuthStoreModule = StoreModule.forFeature(
    userAuthFeatureKey,
    userAuthReducer
);
